
import {fnExists} from '../utils/fnexists'
import {app} from '../globals/objects'


const preloader = () => {

	const $preloader 	= $('.preloader'),
		  $spinner 		= $('.spinner');
	
	if ($preloader.exists()) {
        app.$body.addClass("page-loaded");
        $spinner.fadeOut(300);
        $preloader.delay(600).fadeOut(300);
    }

}

export { preloader }